import styled from 'styled-components';

export const StyledTable = styled.table`
  border-top: 3px solid grey;
`;

export const THead = styled.thead`
 // custom css goes here
`;

export const TFoot = styled.tfoot`
  // custom css goes here
`;

export const TBody = styled.tbody`
 // custom css goes here
`;

export const TR = styled.tr`
  // custom css goes here
`;

export const TH = styled.th`
  padding: 0.5rem;
`;

export const TD = styled.td`
  text-align: center;
  padding: 0.5rem;
`;